<template>
  <div v-if="this.pageDevice != null && isLoginUserPageItemWritable">

    <deviceTabs :current="'attributes'" :pageDevice="pageDevice" :pageUser="pageUser" />

    <div class="m-0 mt-3 mr-2" v-if="pageDevice.disabled == true">
      <b-alert class="m-0 mt-2 mb-2 p-1 pl-2 fontSizeDot9" show variant="danger">
        정지 중이므로 기기의 인증코드를 설정할 수 없습니다.
      </b-alert>
    </div>

    <p class="m-0 mt-2 mr-2 gothic">
      속성을 설정하면 팅커블 IoT 키트에서 값을 읽어갈 수 있습니다. 예를 들어 속성에 LED의 켜짐 여부를 추가하고, IoT 기기에서는 주기적으로 LED 켜짐 여부속성을 확인해서 그 값에 따라서 LED등을 켜고 끌 수 있습니다(클라이언트 풀링).
    </p>

    <div class="mt-2">
      <b-table v-touch:swipe.stop size="sm" striped bordered hover :fields="gridFields" :items="propsArray" selectable select-mode="single" selectedVariant="primary" @row-selected="applyProp" class="propGrid">
        <template v-slot:cell(selected)="data">
          <span v-if="data.rowSelected">✔</span>
        </template>
        <template v-slot:cell(delete)="data">
          <b-button size="sm" @click.self.stop="deleteProp(data.item)" class="pt-dot1 pb-dot1">
            삭제
          </b-button>
        </template>
      </b-table>
    </div>

    <p class="m-0 mt-3 mb-1 mr-2 gothic">
      속성의 이름, 형식, 값을 지정하여 새로운 속성을 추가할 수 있습니다.
    </p>
    <b-form @submit.stop.prevent class="was-validated">
      <b-input-group class="mt-2" size="sm">
        <b-input-group-text slot="prepend" style="min-width : 10rem;">
          <label for="" style="margin-bottom : 0rem">이름</label>
        </b-input-group-text>
        <b-form-input  v-touch:swipe.stop v-model="editName" id="editName" v-b-tooltip.focus title="속성의 이름입니다. 최소 2글자 이상 최대 16글자입니다." v-on:keyup="enterKeyChecker" data-nextfocus="editType" minlength="2" maxlength="16" required trim />
      </b-input-group>
      <b-input-group class="mt-1" size="sm">
        <b-input-group-text slot="prepend" style="min-width : 10rem;">
          <label for="" style="margin-bottom : 0rem">타입</label>
        </b-input-group-text>
        <b-form-select required v-model="editType" id="editType" :options="editTypeOptions" v-b-tooltip.focus title="속성의 타입입니다. 속성의 값을 저장할 때 지정한 타입으로 변환합니다." v-on:keyup="enterKeyChecker" data-nextfocus="editValue"></b-form-select>
      </b-input-group>
      <b-input-group class="mt-1" size="sm">
        <b-input-group-text slot="prepend" style="min-width : 10rem;">
          <label for="" style="margin-bottom : 0rem">값</label>
        </b-input-group-text>
        <b-form-input v-touch:swipe.stop v-model="editValue" id="editValue" required maxlength="128" v-b-tooltip.focus title="속성의 값입니다. 최대 128 글자까지 가능합니다." v-on:keyup="enterKeyChecker" data-nextfocus="saveProp" />
      </b-input-group>
    </b-form>

    <div class="text-right mt-2">
      <b-button type="button" @click="saveProp" variant="danger" id="saveProp" :disabled="this.editName == ''|| this.editValue == '' || this.editType == '' || !this.pageBinded" size="sm">
        <b-spinner small type="grow" class="mr-1" v-if="showSaveSpinner"></b-spinner>
        속성 저장하기
      </b-button>
    </div>

    <p class="m-0 mt-3 mb-1 mr-2 gothic">
      <b>IoT 기기에서 속성을 가져갈 때는</b> {{this.functionsServer + "/app/prop"}} 주소로 GET 방식으로 접속 코드는 acode 인자로, 가져갈 속성의 이름을 name 인자로 해서 요청을 보내면 됩니다. HTTP 응답 본문으로 값을 돌려주므로 값은 문자열로 처리되므로 IoT 기기에서 응답 본문을 속성의 타입에 따라서 직접 알맞은 타입으로 변환해야 합니다. boolean 타입인 경우에는 true면 1을, false면 0을 돌려줍니다.<span v-if="propsNameArray.length > 0">선택 목록 <b-form-select size="sm" v-model="selectedProp" :options="propsNameArray" style="width:auto;"></b-form-select>에서 가져올 속성의 이름을 고르면 아래에 요청을 보낼 주소가 표시됩니다.</span>
    </p>

    <p v-if="propGetURL != ''" class="bg-secondary-lighter p-2" style="overflow: hidden;">
      {{this.propGetURL}}
    </p>

    <p v-if="propGetURL != ''" class="m-0 mt-3 mb-1 mr-2 gothic">
      위의 주소로 속성을 잘 가져오는 지 팅커블 IoT 기기와 동일한 방식으로 요청을 보내봅시다.
      <b-button size="sm" variant="primary" @click="getProp" class="pt-dot1 pb-dot1 fontSizeDot9">{{this.selectedProp + " "}}속성 가져오기</b-button>
      버튼을 누르면 해당 속성의 값을 가져와서 아래에 표시합니다. 응답의 Content-Type은 text/plain입니다. 속성이 없을 때는 403 Forbidden 에러를 돌려줍니다.
    </p>

    <p v-if="propGetURL != ''" class="bg-secondary-lighter p-2" style="overflow: hidden;">
      {{this.getPropResult}}
    </p>

    <p class="m-0 mt-3 mb-1 mr-2 gothic">
      <b>IoT 기기에서 속성을 수정할 때는</b> {{this.functionsServer + "/app/prop"}} 주소로 GET 방식으로 접속 코드는 acode 인자로, 속성의 이름은 name 인자로, 속성의 값은 value 인자로, 속성의 타입은 type 인자로 지정하면 됩니다. type 인자의 값에는 boolean, number, string을 사용할 수 있습니다. boolean 타입인 경우에는 true면 1 또는 true를, false면 0 또는 false를 value 인자의 값으로 지정합니다. type 인자를 지정하지 않으면 속성에 저장된 값의 타입으로 value 인자의 값을 변환합니다.
    </p>

    <p v-if="propPostURL != ''" class="bg-secondary-lighter p-2" style="overflow: hidden;">
      {{this.propPostURL}}
    </p>

    <p class="m-0 mt-3 mb-1 mr-2 gothic">
      <b>IoT 기기에서 속성을 삭제할 때는</b> {{this.functionsServer + "/app/prop"}} 주소로 GET 방식으로 접속 코드는 acode 인자로, 속성의 이름은 name 인자로, remove 인자는 1로 지정하면 됩니다.
    </p>

    <p v-if="propRemoveURL != ''" class="bg-secondary-lighter p-2" style="overflow: hidden;">
      {{this.propRemoveURL}}
    </p>

    <p class="m-0 mt-3 mb-1 mr-2 gothic">
      <b>IoT 기기에서 속성을 추가할 때는</b> {{this.functionsServer + "/app/prop"}} 주소로 GET 방식으로 접속 코드는 acode 인자로, 속성의 이름은 name 인자로, 속성의 초기값은 value 인자로, 속성의 타입은 type 인자, create 인자는 1로 전송하면 됩니다. 아래는 숫자 타입인 newProp 속성을 초기값은 123으로 추가합니다. value 인자가 없는 경우에는 number 타입은 0, boolean 타입은 false, string 타입은 ""를 초기값으로 속성을 만듭니다. type 인자가 없는 경우에는 number 타입으로 생성합니다. 이미 속성이 있는 경우에는 속성을 지정한 타입, 값으로 변경합니다.
    </p>

    <p v-if="propCreateURL != ''" class="bg-secondary-lighter p-2 mb-2" style="overflow: hidden;">
      {{this.propCreateURL}}
    </p>

  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { db } from "@/plugins/firebase.js"

import uiUtil from "@/mixins/util.js"
import mapUtil from "@/mixins/mapUtil.js"
import user from "@/mixins/user.js"
import functions from "@/mixins/functions.js"

import deviceTabs from "@/components/device/deviceTabs.vue"

export default {
  name: "deviceAttributes",
  mixins: [uiUtil, mapUtil, user, functions],
  props: {
    pageUser: Object,
    pageDevice: Object,
    pageBinded: Boolean,
  },
  components: {
    deviceTabs,
  },
  data: function() {
    return {
      showSaveSpinner: false,
      serial: null,
      acode: null,
      gridFields: [
        {
          key: 'selected',
          label: '선택',
          tdClass: "text-center"
        },
        {
          key: 'name',
          label: '이름',
          sortable: true,
          tdClass: "text-left"
        },
        {
          key: 'type',
          label: '형식',
          sortable: true,
          class: "text-left",
        },
        {
          key: 'value',
          label: '값',
          sortable: false,
          class: "text-right",
        },
        {
          key: 'delete',
          label: '삭제',
          sortable: false,
          tdClass:"text-center",
        }
      ],
      editName: "",
      editType: "number",
      editValue: "",
      selectedProp: "",
      selectedType: "number",
      getPropResult: "실행안함",
      editTypeOptions: [
        { text: "숫자", value: "number" },
        { text: "문자열", value: "string" },
        { text: "논리값", value: "boolean" }
      ],
    }
  },
  created: function() {
    firebase.auth().onAuthStateChanged(() => {
      if(firebase.auth().currentUser != null) {
        this.getAcode()
      }
    })
  },
  methods: {

    applyProp: function(items) {
      if(items.length == 1) {
        this.editName = items[0].name
        this.editType = items[0].type
        if(items[0].type == "number") {
          this.editValue = items[0].value + ""
        }
        else if(items[0].type == "boolean") {
          if(items[0].value) {
            this.editValue = "1"
          }
          else {
            this.editValue = "0"
          }
        }
        else {
          this.editValue = items[0].value
        }
        this.selectedProp = items[0].name
        this.selectedType = items[0].type
      }
    },

    deleteProp: function(item) {

      this.pageDevice.logs.splice(0,0,{
        "dt": firebase.firestore.Timestamp.now(),
        "from": "device-upload-deleteProp",
        "level": "info",
        "message": "[" + this.pageDevice.name + "] 기기의 [" + item.name + "] 속성을 삭제했습니다."
      })

      if(this.pageDevice.logs.length > 10) this.pageDevice.logs.splice(10, this.pageDevice.logs.length - 10)
      db.collection("devices").doc(this.pageDevice.id).update({
        ["props." + item.name] : firebase.firestore.FieldValue.delete(),
        "logs": this.pageDevice.logs,
        "lastModified": firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then(()=> {
        this.makeToast("success", "속성 삭제 성공", "속성을 삭제했습니다.")
      })
      .catch(error => {
        this.makeToast("danger", "속성 삭제 실패", "속성 삭제에 실패했습니다. 에러: " + error)
      })
    },
    saveProp: function() {

      this.showSaveSpinner = true

      let value = null
      if(this.editType == "number") {
        value = this.editValue*1
        if(isNaN(value)) {
          this.makeToast("danger", "입력값 에러", "숫자가 아닙니다.")
          this.editValue = ""
          window.document.getElementById("editValue").focus()
          this.showSaveSpinner = false
          return
        }
      }
      else if(this.editType == "boolean") {
        if(this.editValue == "1" || this.editValue.toLowerCase() == "true") {
          value = true
        }
        else {
          value = false
        }
      }
      else {
        value = this.editValue
      }

      this.pageDevice.logs.splice(0,0,{
        "dt": firebase.firestore.Timestamp.now(),
        "from": "device-upload-saveProp",
        "level": "info",
        "message": "[" + this.pageDevice.name + "] 기기의 [" + this.editName + "] 속성을 수정하거나 추가했습니다."
      })

      if(this.pageDevice.logs.length > 10) this.pageDevice.logs.splice(10, this.pageDevice.logs.length - 10)

      db.collection("devices").doc(this.pageDevice.id).update({
        ["props." + this.editName] : value,
        "logs": this.pageDevice.logs,
        "lastModified": firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then(()=> {
        this.makeToast("success", "속성 저장 성공", "속성을 저장했습니다.")
      })
      .catch(error => {
        this.makeToast("danger", "속성 저장 실패", "속성 저장에 실패했습니다. 에러: " + error)
      })
      .finally(() => {
        this.showSaveSpinner = false
      })
    },
    getProp: function() {
      this.getPropResult = "실행중"
      this.get(this.propGetURL)
      .then(result=> {
        this.makeToast("success", "속성 조회 성공", "속성을 가져왔습니다. 속성의 값: " + result.data)
        this.getPropResult = result.data
      })
      .catch(error => {
        this.getPropResult = "실행안함"
        this.makeToast("danger", "속성 조회 실패", "속성을 가져오는 중에 에러가 발생했습니다.")
      })
    },
    getAcode: function() {
      db.collection("acodes").where("device", "==", this.pageDevice.id).where("owner", "==", this.pageUser.id)
      .get()
      .then(acodeList => {
        console.log(acodeList);
        acodeList.forEach(acode => {
          if(acode.exists) {
            this.serial = acode.data().serial
            this.acode = acode.id
          }
        })
      })
      .catch(error => {
        this.makeToast("danger", "접속 코드 조회 실패", "접속 코드 조회 중에 에러가 발생했습니다. 에러 내용:" + error)
      })
    },
  },
  computed: {
    propsNameArray: function() {
      let result = []
      for(let prop in this.pageDevice.props) {
        result.push(prop)
      }
      return result
    },
    propsArray: function() {
      let result = []
      for(let prop in this.pageDevice.props) {
        let item = {}
        item.name = prop
        item.value = this.pageDevice.props[prop]
        if(typeof(this.pageDevice.props[prop]) == "number") item.type = "number"
        else if(typeof(this.pageDevice.props[prop]) == "boolean") item.type = "boolean"
        else item.type = "string"
        result.push(item)
      }
      return result
    },
    propGetURL: function() {
      return (this.selectedProp != "")? this.functionsServer + "/app/prop?acode=" + this.acode + "&name=" + this.selectedProp : ""
    },
    propPostURL: function() {
      return (this.selectedProp != "")? this.functionsServer + "/app/prop?acode=" + this.acode + "&name=" + this.selectedProp +"&value=1&type=" + this.selectedType : ""
    },
    propCreateURL: function() {
      return this.functionsServer + "/app/prop?acode=" + this.acode + "&name=newProp&value=123&type=number&create=1"
    },
    propRemoveURL: function() {
      return (this.selectedProp != "")? this.functionsServer + "/app/prop?acode=" + this.acode + "&name=" + this.selectedProp +"&remove=1" : ""
    },
  }
}
</script>
<style>
.propGrid th { padding : 0.3rem 0.5rem 0.3rem 0.5rem; text-align: center !important; font-size: 0.9rem; }
.propGrid td { padding : 0.3rem 0.5rem 0.3rem 0.5rem; vertical-align: baseline; font-size: 0.9rem; }
</style>
